











































































import { Component, Vue } from 'vue-property-decorator';
import RetailerService from '@/services/retailer.service';

@Component({})
export default class VerifyEmail extends Vue {
  isLoading = true;
  isError = false;
  message = '';
  token = '';

  private async mounted() {
    await this.verifyEmail();
  }

  async verifyEmail() {
    this.isLoading = true;
    this.token = this.$router.currentRoute?.query?.token.toString();
    this.token = this.token.replaceAll(' ', '+');
    try {
      const verifyEmailResp = await RetailerService.verifyEmail(this.token);
      this.isLoading = false;
      this.isError = false;
      this.message = verifyEmailResp?.data?.message || 'Email has been verified';
    } catch (error: any) {
      this.isLoading = false;
      this.isError = true;
      this.message = error?.response?.data?.message || 'Failed to verify email, Please try again';
    }
  }

  async tryAgain() {
    await this.verifyEmail();
  }

  private signIn() {
    this.$router.push('/main');
  }
}
